module.exports = __webpack_public_path__ + "static/media/neko-young-theme.f1353703.wav";